<template>
  <div>
    <RouterView class="router-view" v-slot="{ Component = RelatosList }">
      <Transition mode="out-in">
        <component
          :is="currentComponent || Component"
          :dataTable="dataTrainings"
        />
      </Transition>
    </RouterView>
  </div>
</template>

<script setup>
import RelatosList from "./pages/RelatosList.vue";
import { computed, onMounted } from "vue";
import { initFlowbite } from "flowbite";
import { dataRcd } from "../store";

const currentComponent = computed(() => dataRcd.getters.getActiveComponent);

onMounted(() => {
  initFlowbite();
});
</script>

<style scoped lang="scss">
.v-enter-from,
.v-leave-to {
  transform: translate(50px);
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}
</style>
